import { Component, Input } from '@angular/core';

import { BillingPaymentPaths, PaymentAccount } from '@amfam/shared/models';

@Component({
  selector: 'ds-expired-payment-account-warning',
  templateUrl: './expired-payment-account-warning.component.html',
  styleUrls: ['./expired-payment-account-warning.component.scss'],
  standalone: false
})
export class ExpiredPaymentAccountWarningComponent {
  @Input() paymentAccount: PaymentAccount;

  // Pass the route constants to the template
  billingPaths = BillingPaymentPaths;

  constructor() {}
}
